import { TableRow } from '@mui/material';

import { LoadingSkeleton, RowTableCell } from '../../../../common/components';

const TableStateRow = ({ colSpan, loading, emptyMessage }) => {
  if (loading) {
    return <LoadingSkeleton />;
  }

  return (
    <TableRow>
      <RowTableCell colSpan={colSpan} sx={{ textAlign: 'center', py: 3 }}>
        {emptyMessage}
      </RowTableCell>
    </TableRow>
  );
};

export default TableStateRow;
